// extracted by mini-css-extract-plugin
export var image = "_j4-1";
export var imageContainer = "_j4-0";